import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { Gql } from '@fiverr-private/dynamic_matching';
import { useBriefContext } from '@fiverr-private/ai_brief/dist/esm/src/common/BriefContext';
import { AppI18n } from '../../../i18n';
import { useBriefCreationContext } from '../../../context/BriefCreationContext';
import { BUDGET_AND_TIMELINE_SECTION_ID } from '../BudgetAndTimeline';
import { BudgetAndTimelineContent } from '../BudgetAndTimeline/utils/types';
import { SectionTag } from '../SectionTag';
import { NEED_TYPE_SECTION_ID } from '..';
import { BriefNeedType } from './types';
import { ADDITIONAL_WORK_CHECKBOX_ID, COPIES_PREFIX } from './consts';

export const AdditionalWorkTag: React.FC = () => {
  const { brief, enableEnhancedUx } = useBriefCreationContext();
  const { updateEditedBrief, setEditedSectionId } = useBriefContext();

  const shouldShowTag = useMemo(() => {
    const needTypeSection = brief?.sections.find((section) => section.id === NEED_TYPE_SECTION_ID);
    const needTypeContent = needTypeSection?.content as unknown as BriefNeedType;

    if (isEmpty(needTypeContent) || needTypeContent.needType !== Gql.DmBriefNeedType.OneTime) {
      return false;
    }

    if (enableEnhancedUx) {
      const budgetAndTimelineSection = brief?.sections?.find((s) => s.id === BUDGET_AND_TIMELINE_SECTION_ID);
      const budgetAndTimelineContent = budgetAndTimelineSection?.content as unknown as BudgetAndTimelineContent;

      return Boolean(budgetAndTimelineContent?.ongoingWorkPotential);
    }

    return Boolean(needTypeContent?.ongoingWorkPotential);
  }, [brief, enableEnhancedUx]);

  const handleClick = async (e: React.MouseEvent) => {
    if (enableEnhancedUx) {
      e.stopPropagation();
      updateEditedBrief(null, BUDGET_AND_TIMELINE_SECTION_ID, { focused: true });
      setEditedSectionId(BUDGET_AND_TIMELINE_SECTION_ID);

      requestAnimationFrame(() => {
        const checkbox = document.getElementById(ADDITIONAL_WORK_CHECKBOX_ID);
        if (!checkbox) {
          return;
        }

        checkbox?.focus({ preventScroll: true });

        checkbox.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    }
  };

  if (!shouldShowTag) {
    return null;
  }

  return (
    <SectionTag onClick={enableEnhancedUx ? handleClick : undefined}>
      <AppI18n k={`${COPIES_PREFIX}.additional_work.indicator`} />
    </SectionTag>
  );
};
